import { type AcfMediaItemConnectionEdge } from "~/__generated__/graphql";
import Image from "next/image";
import { cn } from "~/utils/cn";

export default function CustomImage({
  data,
  className = "",
  loadingType = "lazy",
  sizes = "(max-width: 1920px) 100vw, 1920px",
  priority = false,
}: {
  data?: AcfMediaItemConnectionEdge | null;
  className?: string;
  loadingType?: "lazy" | "eager";
  width?: number;
  height?: number;
  /** Without sizes, the browser assumes the image is always 100vw for any viewport.
      A helpful tool to determine proper sizes https://ausi.github.io/respimagelint/ */
  sizes?: string;
  priority?: boolean;
}) {
  const imageSource = data?.node.sourceUrl;
  const alt = data?.node.altText ?? "";

  // To reserve space for the image, if its not available we don't pass it to
  // img element
  // const { height = null, width = null } = dimensions ?? {};

  //If there is no source, we can't show anything
  if (!imageSource) return null;

  return (
    <Image
      src={imageSource}
      alt={alt}
      // sizes={data.node.sizes ?? "100vw"}
      sizes={sizes}
      width={0}
      height={0}
      priority={priority}
      // quality={100}
      loading={loadingType}
      className={cn("h-auto w-full", className)}
    />
  );
}
